import { DatePicker, Input, Select } from 'antd'
import React, { useEffect, useState } from 'react'
import CustomersDropdown from '../../CustomersDropdown'
import dayjs from 'dayjs'
import { toast } from 'react-toastify'
import Loader from '../../../pages/pages/loader'
import AddServiceCampaignModal from './AddServiceCampaignModal'
import { useDeleteCustomerCampaignServiceMutation } from '../../../redux/apis/campaignsManagement/customerCampaign/cMCustomerCampaignApiSlice'
import ServicesDropdown from '../../ServicesDropdown'
import { can } from '../../../helpers/auth'

const StepTwo = ({ data, refetch }) => {
  let services = data?.customer_services

  const [deactivateService, { isLoading, error, isSuccess }] =
    useDeleteCustomerCampaignServiceMutation()
  const [holder, setHolder] = useState(null)
  const [open, setOpen] = useState(false)

  useEffect(() => {
    if (error?.data) {
      const errorMessages = Object.values(error.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    }
  }, [error])

  useEffect(() => {
    if (isSuccess) {
      toast.success('Campaign Service Deactivated!')
      refetch()
    }
  }, [isSuccess])
  return (
    <div>
      <Loader isLoading={isLoading} />

      <div className=' mb-3 flex-1 customInput'>
        <label className="form-label">Campaign Name</label>
        <Input
          type='text'
          name='campaign_name'
          value={data?.campaign_name}
          disabled
        />
      </div>
      {services?.map(service => (
        <div className='flex gap-8 ' key={service?.id}>
          <CustomersDropdown
            onBlur={() => {}}
            onChange={() => {}}
            value={service?.customer?.id}
            disabled={true}
            className='customSelect'
          />
          <div className=' mb-3 customeDate flex-1'>
            <label className="form-label">Start Date</label>
            <br />
            <DatePicker
              style={{ width: '100%' }}
              value={dayjs(service?.start_date)}
              disabled
            />
          </div>
          <div className=' mb-3 customeDate flex-1'>
            <label className="form-label">End Date</label>
            <br />
            <DatePicker
              style={{ width: '100%' }}
              value={dayjs(service?.end_date)}
              disabled
            />
          </div>
          <div className=' mb-3 flex-1'>
            <label className="form-label">Mode</label>
            <br />
            <Select
              className={'customSelect'}
              style={{
                width: '100%'
              }}
              value={service?.is_takedown}
              options={[
                { label: 'Take Down', value: true },
                { label: 'Monitoring', value: false }
              ]}
              disabled
            />
          </div>
          <ServicesDropdown
            onBlur={() => {}}
            onChange={() => {}}
            value={service?.service}
            disabled={true}
            className='customSelect'
            service_category='1'
          />
          <div className=' mb-3 flex-1 customInput'>
            <label className="form-label">Frequancy</label>
            <Input
              type='text'
              name='Frequancy'
              value={service?.service_frequency}
              disabled
            />
          </div>
          {service?.is_active ? (
            <div className='flex gap-2 items-center'>
              <button
                className='btn btn-danger w-28'
                onClick={() => {
                  deactivateService(service?.id)
                }}
              >
                Deactivate
              </button>
              {can('post_campaign_services') && (
                <button
                  className='btn btn-theme w-28'
                  onClick={() => {
                    setHolder(service);
                    setOpen(true)
                  }}
                >
                  Duplicate
                </button>
              )}
            </div>
          ) : (
            <div className='flex gap-2 items-center'>
              <button className='btn w-28' disabled>
                InActive
              </button>
              {can('post_campaign_services') && (
                <button
                  className='btn btn-theme w-28'
                  onClick={() => {
                    setHolder(service);
                    setOpen(true)
                  }}
                >
                  Duplicate
                </button>
              )}
            </div>
          )}
        </div>
      ))}
      {can('post_campaign_services') && (
        <AddServiceCampaignModal
          data={data}
          refetch={refetch}
          open={open}
          setOpen={setOpen}
          holder={holder}
        />
      )}
    </div>
  )
}

export default StepTwo
